import {
  DEFAULT_MODEL_RESPONSE_RANKING_TITLE,
  DEFAULT_MODEL_RESPONSE_RANKING_SUBTITLE,
  InteractionStepType,
} from '@scale/shared/types/chat';
import StringInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/StringInputBuilder';
import BooleanInputBuilder from 'react-scale/corp/components/QM/taskTemplatesEditor/BooleanInputBuilder';
import {
  EnableRTLTextConfig,
  ConditionalStepConfig,
  ReviewLevelConfig,
} from 'react-scale/components/scalers/tasks/ThreadedInteraction/definitions/configs';
import { StepConfigurationComponentProps } from '../../stepDescriptor/types';
import { memo } from 'react';

const ModelResponseRankingConfigurationComponent = ({
  params: currentParams,
  setParams: setCurrentParams,
  previousParams,
  taskParams,
}: StepConfigurationComponentProps<InteractionStepType.ModelResponseRanking>) => {
  return (
    <div className="flex flex-col gap-4">
      <StringInputBuilder
        name={'Title'}
        placeholder={DEFAULT_MODEL_RESPONSE_RANKING_TITLE}
        existingValue={currentParams.title}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, title: value })}
        required={true}
      />

      <StringInputBuilder
        name={'Subtitle'}
        placeholder={DEFAULT_MODEL_RESPONSE_RANKING_SUBTITLE}
        existingValue={currentParams.subtitle}
        updateProperty={(value: string) => setCurrentParams({ ...currentParams, subtitle: value })}
      />

      <EnableRTLTextConfig
        value={currentParams.params.enable_rtl_text}
        onChange={value => {
          setCurrentParams({
            ...currentParams,
            params: { ...currentParams.params, enable_rtl_text: value },
          });
        }}
      />

      <div className="flex flex-col gap-2">
        <BooleanInputBuilder
          name={'Allow Ties'}
          existingValue={!!currentParams.params.allow_ties}
          updateProperty={value => {
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, allow_ties: value },
            });
          }}
        />
        <div className="prose text-sm italic ml-8">If enabled, tied rankings are allowed.</div>
      </div>

      <div className="flex flex-col gap-2">
        <StringInputBuilder
          name={'[Advanced] Always Pass Down the Below Response'}
          existingValue={currentParams.params.always_send_given_id}
          updateProperty={(value: string) =>
            setCurrentParams({
              ...currentParams,
              params: { ...currentParams.params, always_send_given_id: value },
            })
          }
        />
        <div className="prose text-sm italic">
          Regardless of which response the tasker selects, this config will pass down a specific
          response ID to be used in later steps. This is often used in pipelines where even if the
          model response is better than the human response, we want to pass the human response down
          to future taskers for comparison.
        </div>
      </div>

      <ReviewLevelConfig currentParams={currentParams} setCurrentParams={setCurrentParams} />

      <ConditionalStepConfig
        currentParams={currentParams}
        setCurrentParams={setCurrentParams}
        previousParams={previousParams}
        taskParams={taskParams}
      />
    </div>
  );
};

export default memo(ModelResponseRankingConfigurationComponent);
